import ConfirmationModal from "@/modules/common/components/modals/cofirmation-modal";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import {
  PermissionLevel,
  PermissionsEnum,
  TOAST_IDS,
  ToastType,
} from "@/modules/common/types";
import { showToast } from "@/modules/common/utils";
import { useUnarchiveTrack } from "@/modules/property-tracks/hooks/archive-track/unarchive-track.hook";
import { MenuItem } from "@mui/material";
import { ArchiveRestore } from "lucide-react";
import { useState } from "react";

interface UnarchiveTrackMenuItemProps {
  track: {
    uid: string;
    archivedAt?: Date;
  };
}

export default function UnarchiveTrackMenuItem({
  track,
}: UnarchiveTrackMenuItemProps) {
  if (!track.archivedAt) return;

  const [open, setOpen] = useState(false);

  const mutation = useUnarchiveTrack();

  const handleSubmit = () => {
    mutation.mutate(
      { uid: track.uid },
      {
        onSuccess: () => {
          showToast({
            type: ToastType.SUCCESS,
            message: "Track unarchived successfully",
            toastId: TOAST_IDS.UNARCHIVE_TRACK_SUCCESS,
          });
        },
        onError: (error) => {
          showToast({
            type: ToastType.ERROR,
            message:
              error?.response?.data?.message ||
              "Unexpected error occurred. Please try again.",
            toastId: TOAST_IDS.UNARCHIVE_TRACK_ERROR,
          });
        },
      }
    );
  };

  return (
    <PermissionGuard
      permissions={[
        {
          name: PermissionsEnum.ARCHIVE_TRACK,
          level: PermissionLevel.WRITE,
        },
      ]}
    >
      <MenuItem
        sx={(t) => ({
          display: "flex",
          alignItems: "center",
          gap: t.nawy.spacing.sm,
        })}
        onClick={() => setOpen(true)}
      >
        <ArchiveRestore /> Unarchive Track
      </MenuItem>

      <ConfirmationModal
        open={open}
        setOpen={setOpen}
        onConfirmHandler={handleSubmit}
        title="Unarchive Track"
        body="Are you sure you want to unarchive this track?"
        isLoading={mutation.isPending}
      />
    </PermissionGuard>
  );
}
